import { FC } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { MessageImageDTO } from '../../../../type/dto/RequestResponseDTO';

interface MessageImagesProps {
    images: MessageImageDTO[];
    onImageClick: (imageUrl: string) => void;
}

export const MessageImages: FC<MessageImagesProps> = ({ images, onImageClick }) => {
    if (!images || images.length === 0) return null;

    return (
        <Box sx={{ mb: 1.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                <ImageIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                {images.length} image(s)
            </Typography>
            <Grid container spacing={1}>
                {images.map((img) => (
                    <Grid item key={img.id}>
                        <Box
                            component="img"
                            src={img.imageThumbUrl || img.imageUrl}
                            alt={img.text || 'Message image'}
                            sx={{
                                width: 80,
                                height: 80,
                                objectFit: 'cover',
                                borderRadius: 1,
                                cursor: 'pointer',
                                border: '1px solid',
                                borderColor: 'divider',
                                '&:hover': {
                                    opacity: 0.8,
                                },
                            }}
                            onClick={() => onImageClick(img.imageUrl)}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

